import React, { useEffect, useState } from 'react';
import { Divider, HStack, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { useApiError, useLibreDataShare } from 'Hooks';
import { Link } from 'Components/utility';
import { formatDataShareCode } from 'Utilities/dataHelpers';
import { formatTimestamp } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const LibreDataShareCard = ({ dataShareConnection }) => {
    const [hasCode, setHasCode] = useState(!!dataShareConnection);
    const { monthDate, time } = formatTimestamp(dataShareConnection?.expiresAt || 0);
    const [loading, setLoading] = useState(false);
    const { createNewDataShare } = useLibreDataShare();
    const { showApiErrorModal } = useApiError();
    useEffect(() => {
        if (!dataShareConnection?.expiresAt) {
            return;
        }
        const msToExpiry = new Date(dataShareConnection.expiresAt * 1000).getTime() - Date.now();
        const timeoutId = setTimeout(() => {
            setHasCode(false);
        }, msToExpiry);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [dataShareConnection?.expiresAt]);
    const handleManageCode = async () => {
        mediator.publish('router:navigate', {
            url: '/lds-connection',
            data: {
                dataShareConnection: dataShareConnection,
            },
        });
    };
    const handleCreateCode = async () => {
        try {
            setLoading(true);
            const dataShareConnection = await createNewDataShare();
            mediator.publish('router:navigate', {
                url: '/lds-connection',
                data: {
                    dataShareConnection: dataShareConnection,
                },
            });
        }
        catch (err) {
            showApiErrorModal();
        }
        finally {
            setLoading(false);
        }
    };
    return (React.createElement(Stack, { marginTop: "$4", padding: "$4", backgroundColor: "$surface.container", border: "$1.5", shadow: "$1" },
        React.createElement(Text, { color: "$text.100", marginBottom: "$3", fontSize: "$h4.strong", fontWeight: "$h4.strong", testID: "LibreDataShareCard.title" }, i18n.t('Connections.content.libreDataShareCard.primaryText')),
        hasCode && dataShareConnection ? (React.createElement(Stack, { alignItems: "center", marginTop: "$3" },
            React.createElement(Text, { testID: "LibreDataShareCard.code", fontSize: "$dataSmall.medium", fontWeight: "$dataSmall.medium", color: "$text.100" }, formatDataShareCode(dataShareConnection.code)),
            React.createElement(Text, { testID: "LibreDataShareCard.expiresAt", fontSize: "$bodySmall.default", fontWeight: "$bodySmall.default", color: "$text.100", marginTop: "$3", marginBottom: "$3" }, i18n.t('Connections.content.libreDataShareCard.bodyText', {
                time,
                monthDate,
            })))) : (React.createElement(Text, { marginBottom: "$4", color: "$text.100", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", testID: "LibreDataShareCard.message" }, i18n.t('Connections.content.libreDataShareCard.secondaryText'))),
        React.createElement(Divider, { marginBottom: "$4", borderColor: "$neutral.40" }),
        React.createElement(HStack, { display: "flex", justifyContent: "center", alignItems: "center" }, loading ? (React.createElement(LoadingSpinner, { testID: "LibreDataShareCard.createCode.spinner" })) : hasCode ? (React.createElement(Link, { disabled: loading, testID: "LibreDataShareCard.createCode-btn", onPress: handleManageCode }, i18n.t('Connections.content.libreDataShareCard.links.manageCode.label'))) : (React.createElement(Link, { disabled: loading, testID: "LibreDataShareCard.createCode-btn", onPress: handleCreateCode }, i18n.t('Connections.content.libreDataShareCard.links.linkText.label'))))));
};
export default LibreDataShareCard;
